<section class="new-chat">
  <header class="new-chat-header">
    <button class="back-btn" (click)="close()" aria-label="Cerrar">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
    </button>
    <h2>Nuevo chat</h2>
  </header>
  <app-contact-list
    [contacts]="contacts()"
    [disabled]="isStartingChat()"
    (selectContact)="onSelectContact($event)"
  />
</section>
